module.exports = __webpack_public_path__ + "img/nt15-19-75-1.prt.5a140bfb.jpg";